import type { Issue, Stored } from "@overmap-ai/common"
import { Mention } from "@tiptap/extension-mention"
import { mergeAttributes, ReactNodeViewRenderer } from "@tiptap/react"

import type { MentionOptions } from "../typings"
import { IssueMentionComponent } from "./Component"
import { suggestion } from "./suggestion"

export const IssueMention = Mention.extend<MentionOptions<Stored<Issue>>>({
	name: "IssueMention",
	atom: true,
	addAttributes() {
		return {
			uuid: {
				default: null,
			},
		}
	},
	parseHTML() {
		return [
			{
				tag: "issue-mention",
			},
		]
	},
	renderHTML({ HTMLAttributes }) {
		return ["issue-mention", mergeAttributes(HTMLAttributes)]
	},
	addNodeView() {
		return ReactNodeViewRenderer(IssueMentionComponent)
	},
}).configure({
	suggestion,
})
